import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-deal-signatory-add-person-modal',
  templateUrl: './deal-signatory-add-person-modal.component.html',
  styleUrls: ['./deal-signatory-add-person-modal.component.scss']
})
export class DealSignatoryAddPersonModalComponent implements OnInit {

  fg: FormGroup = new FormGroup({
    fullName: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email])
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: { fullName: string, email: string}) { }

  ngOnInit(): void {
    if (!!this.data) {
      this.fg.patchValue(this.data);
    }
  }

}
